<template>
    <form action="https://www.paypal.com/cgi-bin/webscr" ref="dataForm" method="post" style="display: none" target="top">
        <input type="hidden" name="cmd" value="_xclick">
        <input type="hidden" name="business" value="helen@nuclearsoft.net">
        <input id="fromtitle" type="hidden" name="item_name" v-model="fromtitle">
        <input id="fromnumber" type="hidden" name="item_number" v-model="fromnumber">
        <input id="fromamout" type="hidden" name="amount" v-model="fromamout">
        <input id="fromcurr" type="hidden" name="currency_code" v-model="fromcurr">
        <input id="fromnotifurl" type="hidden" name="notify_url" v-model="fromnotifurl">
        <input id="fromreturn" type="hidden" name="return" v-model="fromreturn">
        <input id="fromsubmit" type="image" src="static/images/paypal.png" border="0" style="display: none;" name="submit" alt="PayPal － 更安全、更簡單的網上付款方式！">

    </form>
  <el-button type="primary" style="height: 50px;width: 180px;font-size: 18px;font-weight: bold;" @click="btnChagePayment()"  tkey="支付">{{i18n.tkey("lang_pay_1")}}</el-button>

</template>

<script setup>
import {ref, toRef, getCurrentInstance, onMounted, inject} from 'vue'
    import { useUserinfo } from "@/stores/userinfo";

    const props = defineProps(['formObj'])
    const emits = defineEmits(['submit-complete'])
    const { proxy } = getCurrentInstance()
    const i18n = inject("i18n")

    const staticPath = proxy.$ShopopeeUrl

    const userInfoRef = toRef(useUserinfo())

    const fromtitle = ref("")
    const fromnumber = ref("")
    const fromamout = ref("")
    const fromcurr = ref("HKD")
    const fromnotifurl = ref("")
    const fromreturn = ref("")

    onMounted(() => {
        fromtitle.value = props.formObj.fromtitle
        fromnumber.value = props.formObj.fromnumber
        fromamout.value = props.formObj.fromamout
        fromcurr.value = props.formObj.fromcurr
        fromnotifurl.value = `${staticPath}bo/paynotifurl`
        fromreturn.value = "" + `${staticPath}payreturn?Companycode=${userInfoRef.value.companycode}&Order=${fromnumber.value}&amount=${fromamout.value}&currency_code=${fromcurr.value}&PaymentMethod=paypal`


    })
    function btnChagePayment(){
      proxy.$refs.dataForm.submit()
      setTimeout(() => {
        emits("submit-complete")
      }, 250)
    }


</script>

<style scoped>

</style>